import React from "react";
import {FormDefinition, FormState} from "../../lib/forms";
import {LojaObject} from "../../models/Loja";
import fb from "../../lib/firebase";
import {buildModelForm, ModelForm, ModelFormField,
  ModelFormProps, onChangeCallback} from "../../components/ModelFormHOC";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import {validate} from "cnpj";


interface Props extends ModelFormProps {
  history: any;
  app: AppState;
  dispatch: AppDispatch;
  instance?: LojaObject;
  onSubmit: () => void;
}

interface State {
  formDef:FormDefinition;
  loadingEstados: boolean;
  estados: any[];
  loadingCidades: boolean;
  cidades: any[];
  estado: string | undefined;
  cnpj: string | undefined;
  cnpjOk: boolean;
}

export const formDef: FormDefinition = {
  nome: {name: 'nome', label: 'Nome', type: "string", required: true},
  cnpj: {name: 'cnpj', label: 'CNPJ', type: "cnpj", required: true},
  responsavel: {name: 'responsavel', label: 'Responsável', type: "select", required: true},
  proprietario: {name: 'proprietario', label: 'Proprietário', type: "string", required: false},
  gerente: {name: 'gerente', label: 'Gerente', type: "string", required: false},
  balconista_lider: {name: 'balconista_lider', label: 'Balconista líder', type: "string", required: false},
  estado: {name: 'estado', label: 'Estado', type: "searchInput", required: true},
  cidade: {name: 'cidade', label: 'Cidade', type: "searchInput", required: true},
  telefone: {name: 'telefone', label: 'Telefone', type: "telefone", required: true},
  email: {name: 'email', label: 'Email', type: "email", required: false},
  endereco: {name: 'endereco', label: 'Endereço', type: "text", required: true},
  complemento: {name: 'complemento', label: 'Complemento', type: "string", required: false},
  cep: {name: 'cep', label: 'CEP', type: "cep", required: true},
};


class FormLoja extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      formDef: {...formDef},
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      estado: undefined,
      cnpj: undefined,
      cnpjOk: false,
    };
  }

  componentDidMount() {
    this.loadEstados();

    if (this.props.instance) {
      if (this.props.instance.estado) {
        this.loadCidades(this.props.instance.estado);
        this.setState({estado: this.props.instance.estado});
      }

      if (this.props.instance.responsavel)
        this.setReqResponsavel(this.props.instance.responsavel);

      this.setState({cnpjOk: true});
    }
  }

  loadEstados() {
    this.setState({loadingEstados: true}, () => {
      fb.db.collection('estados').get()
        .then(snap => this.setState({estados: fb.col(snap), loadingEstados: false}))
        .catch(() => this.setState({loadingEstados: false}));
    });
  }

  loadCidades(estado: string) {
    if (this.state.loadingCidades)
      return;

    this.setState({loadingCidades: true}, () => {
      fb.db.collection('cidades').where('estado', '==', estado).get()
        .then(snap => {
          const cidades = fb.col(snap);
          // nocache
          if (!this.props.app.online && !cidades.length)
            this.props.dispatch(actions.notifyError(`As cidades do estado ${estado} não estão disponíveis offline ainda!`));
          this.setState({cidades, loadingCidades: false})
        })
        .catch(() => this.setState({loadingCidades: false}));
    });
  }

  onChangeEstado = (value:any, state:FormState) => {
    this.setState({estado: value}, () => {
      if (value && state.estado.value !== value)
        this.loadCidades(value);
    });
  };

  onCreate = (values:any) => {
    return fb.document.create('lojas', values);
  };

  onUpdate = (values:any) => {
    return fb.document.update('lojas', this.props.instance!.id, values)
  };

  onChangeResponsavel:onChangeCallback = (value, formState) => {
    if (!value)
      return;

    this.setReqResponsavel(value);
  };

  setReqResponsavel = (value:any) => {
    // ajustar campos requeridos
    let propReq = false;
    let gereReq = false;

    if (value === 'Proprietário')
      propReq = true;
    else if (value === 'Gerente')
      gereReq = true;
    else
      throw Error(`Unrecognized value for responsavel field: ${value}`);

    this.setState((state) => {
      return {
        formDef: {
          ...state.formDef,
          proprietario: {...state.formDef.proprietario, required: propReq},
          gerente: {...state.formDef.gerente, required: gereReq},
        }
      }
    });
  };

  onChangeCnpj: onChangeCallback = (cnpj) => {
    const cnpjOk = validate(cnpj);
    this.setState({
      cnpj,
      cnpjOk,
    });
  };

  onValidateForm = async (values: any) => {
    // console.log('onValidateForm', values);
    const {cnpj} = values;
    if (!validate(cnpj)) {
      this.props.dispatch(actions.notifyError("CNPJ inválido."));
      return false;
    }

    // validar cnpj ja cadastrado
    if (!this.props.instance || this.props.instance.cnpj !== cnpj) {
      const existente = await fb.db.collection('lojas')
        .where('owner', '==', this.props.app.user.uid)
        .where('cnpj', '==', cnpj).limit(1).get();

      if (existente.size) {
        // console.log(existente.docs[0]);
        this.props.dispatch(actions.notifyError("Este CNPJ já está cadastrado!"));
        return false;
      }
    }

    return true;
  };

  render() {
    return (
      <ModelForm
        entityLabel="Loja"
        ownerId={this.props.app.user.uid}
        gender="f"
        formDefinition={this.state.formDef}
        onCreate={this.onCreate}
        onUpdate={this.onUpdate}
        onComplete={this.props.onSubmit}
        instance={this.props.instance}
        onValidateAsync={this.onValidateForm}
      >
        {
          !this.props.instance &&
            <div className="font-hairline text-xl">
              Digite primeiramente o CNPJ
            </div>
        }

        <ModelFormField
          field="cnpj"
          onChange={this.onChangeCnpj}
        />

        <ModelFormField field="nome"/>

        <ModelFormField
          field="responsavel"
          options={['Proprietário', 'Gerente']}
          onChange={this.onChangeResponsavel}
        />

        <ModelFormField field="proprietario"/>
        <ModelFormField field="gerente"/>
        <ModelFormField field="balconista_lider"/>

        <ModelFormField field="telefone"/>
        <ModelFormField field="email"/>
        <ModelFormField field="endereco" rows={2}/>
        <ModelFormField field="complemento"/>
        <ModelFormField field="cep"/>
        <ModelFormField
          field="estado"
          options={this.state.estados}
          optionLabel="uf"
          optionValue="uf"
          loading={this.state.loadingEstados}
          disabled={this.state.loadingEstados}
          onChange={this.onChangeEstado}
        />
        <ModelFormField
          field="cidade"
          options={this.state.cidades}
          optionLabel="nome"
          optionValue="nome"
          loading={this.state.loadingCidades}
          disabled={
            (!this.state.estado) || this.state.loadingCidades
          }
        />
      </ModelForm>
    )
  }
}

const FormLojaHOC = buildModelForm(FormLoja);
export default connect(({app}: RootState) => ({app}))(FormLojaHOC);